export const BRAND = {
  name: 'Clan Group',
  tagline: 'Engineering Progress Across Industries',
  website: 'www.clangrp.com',
  email: 'info@clangrp.com',
  established: 2010,
  hq: 'Mumbai, India',
  regions: ['India', 'Africa', 'Middle East'],
  logo: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/fi41hskj_Clan%20Group.png',
};

export const IMAGES = {
  hero: 'https://images.pexels.com/photos/9407363/pexels-photo-9407363.jpeg',
  heroAlt: 'https://images.pexels.com/photos/9407363/pexels-photo-9407363.jpeg',
  infra: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/lvaj16ia_CLan%20Infra%20COn%20.jpeg',
  epc: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/gw7vtvc9_Clan%20Infra%20Con.jpeg',
  textile: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/xv8zg318_Clan%20tex%20Installation.jpeg',
  weldmatix: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/3yq7a1bp_WELDMATIX.jpg',
  weldmatixSystem: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/gep0ujr0_pipe%20rig.jpg',
  weldmatixVCS: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/84s2lt2f_VCS.jpg',
  weldmatixCRT: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/3yq7a1bp_WELDMATIX.jpg',
  weldmatixOCS: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/hzk7t55z_OMNI.jpg',
  zolvix: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71',
  hospitality: 'https://images.unsplash.com/photo-1675077978387-3975ed3579b4',
  metro: 'https://images.pexels.com/photos/10634036/pexels-photo-10634036.jpeg',
  team: 'https://images.unsplash.com/photo-1758518731706-be5d5230e5a5',
  benin: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/999mng22_CLAN%20TEX%20Installation%20-%20Benin%20Project%20.jpeg',
  utility: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/dnn07kgv_Utility%20Installation%20.jpeg',
  steel: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/7058qw7x_International%20Turnkey%20project.jpeg',
  careers: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1600&q=80',
  processPiping: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/ftdx2l5u_Fire%20Hydrant%20.jpeg',
};

export const METRICS = [
  { value: 60, suffix: '+', label: 'Projects Delivered' },
  { value: 15, suffix: '+', label: 'Years Experience' },
  { value: 200, suffix: '+', label: 'Employees' },
  { value: 10, suffix: '+', label: 'Countries Served' },
  { value: 5, suffix: '+', label: 'Business Verticals' },
];

export const COMPANIES = [
  {
    slug: 'clan-infra-con',
    name: 'Clan Infra-Con',
    discipline: 'Civil Infrastructure',
    summary:
      'Roads, railways, metro projects, structural works and industrial civil construction delivered with precision and scale.',
    capabilities: ['Roads & Highways', 'Railways', 'Metro Projects', 'Structural Works', 'Industrial Civil Construction'],
    image: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/lvaj16ia_CLan%20Infra%20COn%20.jpeg',
    accent: '#1B3A8A',
    href: '/group-companies#clan-infra-con',
    external: false,
  },
  {
    slug: 'clan-engineering',
    name: 'Clan Engineering',
    discipline: 'Industrial EPC & Engineering Solutions',
    summary:
      'Turnkey industrial projects, process piping, fire hydrant systems, steel structures, fabrication and erection.',
    capabilities: ['Turnkey Projects', 'Process Piping', 'Fire Hydrant Systems', 'Steel Structures', 'Fabrication & Erection'],
    image: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/astvci5a_Clan%20Eng.png',
    accent: '#D4AF37',
    href: '/group-companies#clan-engineering',
    external: false,
  },
  {
    slug: 'clan-tex-installations',
    name: 'Clan Tex Installations',
    discipline: 'Textile Engineering Specialists',
    summary:
      'End-to-end textile plant installation, ZLD & ETP systems, utility piping, machine relocation and boiler house installation.',
    capabilities: ['Textile Plant Installation', 'ZLD Systems', 'ETP Plants', 'Utility Piping', 'Machine Relocation', 'Boiler House'],
    image: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/5r8le9cs_tex%20Process.jpeg',
    accent: '#2A9D8F',
    href: '/group-companies#clan-tex-installations',
    external: false,
  },
  {
    slug: 'weldmatix-fusion',
    name: 'Weldmatix Fusion',
    discipline: 'Advanced Weld Overlay & Automation',
    summary:
      'Global industrial solutions for cladding systems, automation technologies and pipeline welding — engineered for oil & gas, valve and CRA industries.',
    capabilities: ['Cladding Systems', 'Automation Technologies', 'Pipeline Welding', 'Vertical Clad Stations', 'OMNI Clad Station'],
    image: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/3yq7a1bp_WELDMATIX.jpg',
    accent: '#D4AF37',
    href: 'https://weldmatixco.com',
    external: true,
    cta: 'Visit Weldmatix Fusion',
  },
  {
    slug: 'zolvix-technologies',
    name: 'Zolvix Technologies',
    discipline: 'Technology & SaaS',
    tag: 'Solve · Build · Scale',
    summary:
      'Apps, platforms, SaaS products and digital transformation for industrial-grade enterprises.',
    capabilities: ['Apps', 'Platforms', 'SaaS Products', 'Digital Transformation'],
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71',
    accent: '#1B3A8A',
    href: 'https://zolvix.in',
    external: true,
    cta: 'Visit Zolvix Technologies',
  },
  {
    slug: 'hospitality',
    name: 'Hospitality Division',
    discipline: 'Consumer Experiences',
    summary: 'Restaurants, cafés and food brands creating distinctive consumer experiences.',
    capabilities: ['Restaurants', 'Cafés', 'Food Brands', 'Consumer Experiences'],
    image: 'https://images.unsplash.com/photo-1675077978387-3975ed3579b4',
    accent: '#2A9D8F',
    href: '/group-companies#hospitality',
    external: false,
  },
];

export const INDUSTRIES = [
  { name: 'Infrastructure', icon: 'Building2' },
  { name: 'Construction', icon: 'HardHat' },
  { name: 'Industrial Manufacturing', icon: 'Factory' },
  { name: 'Textiles', icon: 'Shirt' },
  { name: 'Oil & Gas', icon: 'Flame' },
  { name: 'Energy', icon: 'Zap' },
  { name: 'Utilities', icon: 'Droplets' },
  { name: 'Technology', icon: 'Cpu' },
  { name: 'Hospitality', icon: 'UtensilsCrossed' },
];

export const PROJECTS = [
  {
    slug: 'benin-textile',
    name: 'Benin Textile Plant — Turnkey Installation',
    location: 'Benin, West Africa',
    client: 'Confidential Textile Major',
    industry: 'Textile Engineering',
    scope: '54+ machines installed · Complete plant execution · Utility & piping commissioning',
    image: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/999mng22_CLAN%20TEX%20Installation%20-%20Benin%20Project%20.jpeg',
    status: 'Delivered',
    year: '2023',
  },
  {
    slug: 'industrial-utilities',
    name: 'Industrial Utility Installations',
    location: 'Gujarat, India',
    client: 'Process Industries Cluster',
    industry: 'Industrial EPC',
    scope: 'Process piping, boiler house and utility systems for multi-tenant industrial facility.',
    image: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/dnn07kgv_Utility%20Installation%20.jpeg',
    status: 'Delivered',
    year: '2022',
  },
  {
    slug: 'metro-infra',
    name: 'Metro Infrastructure — Structural & Civil',
    location: 'India',
    client: 'Urban Transit Authority',
    industry: 'Infrastructure',
    scope: 'Structural works and civil infrastructure for metro corridor segments.',
    image: 'https://images.pexels.com/photos/10634036/pexels-photo-10634036.jpeg',
    status: 'In Progress',
    year: '2024',
  },
  {
    slug: 'international-turnkey',
    name: 'International Turnkey Engineering',
    location: 'Africa · Middle East · India',
    client: 'Multiple Industrial Clients',
    industry: 'Industrial EPC',
    scope: 'Cross-border turnkey project delivery, equipment relocation and commissioning.',
    image: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/7058qw7x_International%20Turnkey%20project.jpeg',
    status: 'Ongoing',
    year: '2024',
  },
  {
    slug: 'weld-overlay',
    name: 'Weld Overlay & Cladding — CRA Industries',
    location: 'India · Middle East',
    client: 'Oil & Gas and Valve Manufacturers',
    industry: 'Welding Automation',
    scope: 'Vertical Clad Stations, Continuous Rotating Torch and pipe cladding systems deployed.',
    image: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/c8kysb47_WELD%20OVERLAY%20CLADDING%20.jpg',
    status: 'Delivered',
    year: '2023',
  },
  {
    slug: 'process-piping',
    name: 'Fire Hydrant & Process Piping Systems',
    location: 'India',
    client: 'Industrial & Manufacturing Plants',
    industry: 'Industrial EPC',
    scope: 'Design, fabrication and erection of fire hydrant networks and process piping.',
    image: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/ftdx2l5u_Fire%20Hydrant%20.jpeg',
    status: 'Delivered',
    year: '2022',
  },
];

export const COUNTRIES = [
  { code: 'IN', name: 'India', flag: '🇮🇳', projects: 38, role: 'Headquarters & Operations' },
  { code: 'AE', name: 'United Arab Emirates', flag: '🇦🇪', projects: 6, role: 'Regional Hub' },
  { code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦', projects: 3, role: 'Industrial EPC' },
  { code: 'OM', name: 'Oman', flag: '🇴🇲', projects: 1, role: 'Industrial Projects' },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧', projects: 4, role: 'Engineering & Technology' },
  { code: 'BJ', name: 'Benin', flag: '🇧🇯', projects: 3, role: 'Textile Engineering' },
  { code: 'MZ', name: 'Mozambique', flag: '🇲🇿', projects: 2, role: 'Industrial Projects' },
  { code: 'TZ', name: 'Tanzania', flag: '🇹🇿', projects: 2, role: 'Industrial Projects' },
  { code: 'ET', name: 'Ethiopia', flag: '🇪🇹', projects: 1, role: 'Industrial Projects' },
];

export const FUTURE_REGIONS = ['Kenya', 'Qatar', 'Nigeria', 'Bahrain'];

export const VALUES = [
  { title: 'Execution Excellence', desc: 'Delivery discipline across complex, multi-site programs.' },
  { title: 'Integrity', desc: 'Transparent commitments, honest reporting and accountable governance.' },
  { title: 'Innovation', desc: 'Engineering-led problem solving with modern automation and digital systems.' },
  { title: 'Safety', desc: 'Uncompromising HSE standards on every site, every day.' },
  { title: 'Partnership', desc: 'Long-term relationships with clients, vendors and communities.' },
  { title: 'Reliability', desc: 'Predictable performance — on time, on budget, on specification.' },
];

export const CAREER_DOMAINS = [
  'Engineering',
  'Construction',
  'Project Management',
  'Automation',
  'Software Development',
  'Operations',
];

export const SEO_PAGES = {
  'industrial-epc': {
    title: 'Industrial EPC Contractor — Turnkey Engineering Solutions',
    overline: 'Industrial EPC · India · Africa · Middle East',
    headline: 'Turnkey Industrial EPC — Designed, Built & Commissioned',
    description:
      'Clan Group delivers turnkey industrial EPC programs across process industries, with integrated engineering, procurement and construction capabilities.',
    keywords: ['Industrial EPC Contractor India', 'Turnkey Industrial Projects', 'Industrial Engineering Solutions'],
    image: 'https://images.pexels.com/photos/30790481/pexels-photo-30790481.jpeg',
    capabilities: [
      'Engineering, Procurement & Construction',
      'Process & Utility Engineering',
      'Multi-discipline Project Management',
      'Equipment Erection & Commissioning',
      'Quality, Safety & HSE Management',
    ],
    relatedProjects: ['benin-textile', 'industrial-utilities', 'process-piping'],
  },
  'process-piping': {
    title: 'Process Piping Contractor — Industrial Piping Installation',
    overline: 'Process Piping · Fire Hydrant · Utility',
    headline: 'Process Piping & Fire Hydrant Systems',
    description:
      'Specialist process piping contractor delivering industrial piping installations, fire hydrant systems and utility networks for process industries.',
    keywords: ['Process Piping Contractors', 'Industrial Piping Installation', 'Fire Hydrant Systems'],
    image: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/ftdx2l5u_Fire%20Hydrant%20.jpeg',
    capabilities: [
      'Carbon Steel, Stainless & Alloy Piping',
      'Fire Hydrant System Design & Installation',
      'Utility Piping & Distribution Networks',
      'Hydro-testing & Commissioning',
      'Insulation & Painting',
    ],
    relatedProjects: ['industrial-utilities', 'process-piping'],
  },
  'textile-engineering': {
    title: 'Textile Plant Installation — ZLD, ETP & Process House',
    overline: 'Textile Engineering Specialists',
    headline: 'Textile Plant Installation, ZLD & ETP Systems',
    description:
      'End-to-end textile engineering — plant installation, process house, ZLD & ETP plants, utility piping, machine relocation and boiler house installation.',
    keywords: ['Textile Plant Installation', 'Process House Installation', 'ZLD Plant Installation'],
    image: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/xv8zg318_Clan%20tex%20Installation.jpeg',
    capabilities: [
      'Textile Plant Installation',
      'Process House Installation',
      'ZLD & ETP Systems',
      'Utility Piping & Boiler House',
      'Machine Relocation & Commissioning',
    ],
    relatedProjects: ['benin-textile'],
  },
  infrastructure: {
    title: 'Infrastructure Contractors — Metro & Railway Projects',
    overline: 'Civil Infrastructure',
    headline: 'Infrastructure That Moves Nations',
    description:
      'Roads, railways, metro projects, structural works and industrial civil construction — engineered to last.',
    keywords: ['Infrastructure Contractors', 'Metro Projects', 'Railway Infrastructure'],
    image: 'https://images.pexels.com/photos/10634036/pexels-photo-10634036.jpeg',
    capabilities: [
      'Roads & Highways',
      'Railways & Metro Corridors',
      'Structural Works',
      'Industrial Civil Construction',
      'Project Management & Safety',
    ],
    relatedProjects: ['metro-infra'],
  },
  'welding-automation': {
    title: 'Weld Overlay Systems & Industrial Welding Automation',
    overline: 'Welding Automation · Weldmatix Fusion',
    headline: 'Weld Overlay, Cladding & Welding Automation',
    description:
      'Weldmatix Fusion delivers advanced weld overlay, cladding automation and industrial welding automation systems for oil & gas, valves and CRA industries.',
    keywords: ['Weld Overlay Systems', 'Cladding Automation', 'Industrial Welding Automation'],
    image: 'https://customer-assets.emergentagent.com/job_clan-execution-hub/artifacts/3yq7a1bp_WELDMATIX.jpg',
    capabilities: [
      'Pipe Cladding Rig (Twin / Quad Head)',
      'Vertical Clad Station (VCS)',
      'Continuous Rotating Torch (CRT)',
      'OMNI Clad Station',
      'Butt Welding Station & Auto DPT Rig',
    ],
    relatedProjects: ['weld-overlay'],
    externalUrl: 'https://weldmatixco.com',
    externalLabel: 'Explore Weldmatix Fusion',
  },
  'software-development': {
    title: 'SaaS Development Company — Enterprise Software Solutions',
    overline: 'Technology · Zolvix Technologies',
    headline: 'Software, SaaS & Enterprise Platforms',
    description:
      'Zolvix Technologies — Solve, Build, Scale. SaaS products, business applications and enterprise software for industrial-grade clients.',
    keywords: ['SaaS Development Company', 'Business Applications', 'Enterprise Software Solutions'],
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71',
    capabilities: [
      'SaaS Product Engineering',
      'Business Applications',
      'Enterprise Software Solutions',
      'Cloud, DevOps & Data Platforms',
      'AI-enabled Workflows',
    ],
    relatedProjects: [],
    externalUrl: 'https://zolvix.in',
    externalLabel: 'Explore Zolvix Technologies',
  },
};
